/* eslint-disable no-underscore-dangle */

class Bridge {
  static _instance = null

  queue = {
    android: [],
    ios: [],
    iosWk: [],
    web: [],
  }

  static get instance() {
    if (!Bridge._instance) {
      Bridge._instance = new Bridge()
    }
    return Bridge._instance
  }

  send(payload) {
    Object.keys(this.queue).forEach((platform) => {
      this.queue[platform].push(payload)
    })
    this.dispatch()
  }

  dispatch() {
    if (typeof window !== 'undefined') {
      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        this.queue.web.forEach((payload) => {
          window.ReactNativeWebView.postMessage(JSON.stringify(payload))
        })
        this.queue.web = []
      }
      if (typeof AndroidFunction !== 'undefined') {
        this.queue.android.forEach((payload) => {
          /* global AndroidFunction AndroidFunction:writable */
          /* eslint no-undef: "error" */
          AndroidFunction.postMessage(JSON.stringify(payload))
        })
        this.queue.android = []
      }
      if (window.setupWebViewJavascriptBridge) {
        this.queue.ios.forEach((payload) => {
          window.setupWebViewJavascriptBridge((bridge) => {
            bridge.callHandler('postMessage', payload)
          })
        })
        this.queue.ios = []
      }
      if (window.setupWKWebViewJavascriptBridge) {
        this.queue.iosWk.forEach((payload) => {
          window.setupWKWebViewJavascriptBridge((bridge) => {
            bridge.callHandler('postMessage', payload)
          })
        })
        this.queue.iosWk = []
      }
    }
  }
}

export default Bridge.instance
